export function toEpochMicros(createdAt: string): number {
  const ms = new Date(createdAt).getTime();
  if (Number.isNaN(ms)) return 0;
  return ms * 1000;
}
